/** @jsxImportSource @emotion/react */
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { accessAPI, formatFecha, TablaFiltrable } from "../../shared";

import { Accordion, AccordionTab } from "primereact/accordion";
import { Column } from "primereact/column";
import { Skeleton } from "primereact/skeleton";
import { Tag } from "primereact/tag";

const FILTROS = [];
const SEARCH_FIELDS = [
  "_solicitudNombreFantasia",
  "_clienteRazonSocial",
  "_clienteNombreFantasia"
];

export default function PropuestasPendientes({ toast }) {
  const [propuestas, setPropuestas] = useState();
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  useEffect(() => {
    accessAPI(
      "GET",
      "admin/destacados/propuestaspendientes",
      null,
      (respuesta) => {
        setPropuestas(respuesta);
        setLoading(false);
      },
      (respuesta) => {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: respuesta[0]?.msg || "Error al cargar propuestas",
          sticky: true
        });
        setLoading(false);
      }
    );
  }, [toast]);

  if (!loading && (!propuestas || propuestas.length === 0)) {
    return null;
  }

  if (loading) {
    return (
      <div css={{ marginTop: "1em" }}>
        <Skeleton width="100%" height="3.5rem" borderRadius="6px" />
      </div>
    );
  }

  const clienteBody = (propuesta) => {
    return propuesta.cliente.nombrefantasia &&
      propuesta.cliente.nombrefantasia !== propuesta.cliente.razonsocial
      ? `${propuesta.cliente.razonsocial} (${propuesta.cliente.nombrefantasia})`
      : propuesta.cliente.razonsocial;
  };

  const estadoBody = (propuesta) => {
    return propuesta.fechaemision ? (
      <Tag value="Enviada" severity="warning" />
    ) : (
      <Tag value="Sin enviar" severity="danger" />
    );
  };

  const fechaBody = (propuesta) => {
    return formatFecha(propuesta.fechaemision || propuesta.fechacreacion);
  };

  const datos = (propuestas || []).map((p) => ({
    ...p,
    _solicitudNombreFantasia: p.solicitud?.nombrefantasia,
    _clienteRazonSocial: p.cliente?.razonsocial,
    _clienteNombreFantasia: p.cliente?.nombrefantasia
  }));

  return (
    <Accordion
      activeIndex={null}
      css={{
        marginTop: "1em",
        "& .p-accordion-header-link": { color: "black" },
        "& .p-toggleable-content": { transition: "max-height 0.15s ease" }
      }}
    >
      <AccordionTab header={`Propuestas comerciales (${propuestas.length})`}>
        <TablaFiltrable
          value={datos}
          filtros={FILTROS}
          searchFields={SEARCH_FIELDS}
          nombreArchivo="propuestas_pendientes"
          onRowClick={(e) => {
            const url = `/propuesta/${e.data.id}?volver=/`;
            e.originalEvent.metaKey || e.originalEvent.ctrlKey
              ? window.open(url, "_blank")
              : navigate(url);
          }}
          stripedRows
          emptyMessage="No hay propuestas pendientes"
          css={{
            "& .p-datatable-tbody > tr": {
              cursor: "pointer"
            }
          }}
        >
          <Column header="Cliente" body={clienteBody} />
          <Column header="Solicitud" field="solicitud.nombrefantasia" />
          <Column
            header="Estado"
            body={estadoBody}
            alignHeader="center"
            bodyStyle={{ textAlign: "center" }}
            style={{ width: "10em" }}
          />
          <Column header="Fecha" body={fechaBody} style={{ width: "10em" }} />
        </TablaFiltrable>
      </AccordionTab>
    </Accordion>
  );
}
